module.exports = __webpack_public_path__ + "static/media/service4.fe1c380c.svg";